export default "__VITE_ASSET__CUZ2ETBz__"